const colorConfigs = {
    primary: "var(--color-primary)",
    primaryHover: "var(--color-primary-hover)",
    accent: "var(--color-accent)",
    secondary: "var(--color-secondary)",
    tertiary: "var(--color-tertiary)",
    quaternary: "var(--color-quaternary)",
    primaryActiveBg: "var(--color-primary-active-bg)",
    greytext: "var(--color-greytext)",
    mainbody: "var(--color-mainbody)",
    errorBg: "var(--color-error-bg)",
    backgroundColor: "var(--color-background)",
    textColor: "var(--color-text)",
    footerText: "var(--color-footer-text)",
    tastebudButtonText: "var(--color-tastebud-button-text)",
    productCarouselText: "var(--color-product-carousel-text)",
    videoButtonText: "var(--color-video-button-text)",
    topbarCollectionText: "var(--color-topbar-collection-text)",
    collectionProductButtonText: "var(--color-collection-product-button-text)",
    smartFridgeContactText: "var(--color-smart-fridge-contact-text)",
    smartFridgeContactLink: "var(--color-smart-fridge-contact-link)",
    white: "var(--color-white)",
    black: "var(--color-black)",
    transparent: "var(--color-transparent)",
    divider: "var(--color-divider)",
    softBackground: "var(--color-soft-background)",
    subtleBackground: "var(--color-subtle-background)",
    mutedBackground: "var(--color-muted-background)",
    disabledBackground: "var(--color-disabled-background)",
    disabledBorder: "var(--color-disabled-border)",
    mutedText: "var(--color-muted-text)",
    voucherTimeText: "var(--color-voucher-time-text)",
    successText: "var(--color-success-text)",
    successLight: "var(--color-success-light)",
    rewardNegative: "var(--color-reward-negative)",
    warningBackground: "var(--color-warning-background)",
    paymentPurple: "var(--color-payment-purple)",

    backgrounds: {
        main: "var(--color-mainbody)",
        light: "var(--color-background)",
        white: "var(--color-white)",
        card: "var(--color-quaternary)",
        boxshadow: '0px 8px 16px var(--color-shadow-07)',
    },

    whatsapp: {
        backgroundColor: 'var(--color-whatsapp)',
        color: 'var(--color-white)',
        '&:hover': {
            backgroundColor: 'var(--color-whatsapp-hover)',
        },
    }
};

export default colorConfigs;